import { Navbar } from "../shared/components/navbar/Navbar.js";

// Red de seguridad para quien escriba una ruta a mano: el navbar y la home ya
// muestran solo lo permitido.

export const NoDisponibleController = {
  render() {
    const contenido = `
      <div class="container containerapp">
        <h2 class="titseccion">Sección no disponible</h2>
        <div class="alert alert-warning">
          <i class="fas fa-lock me-2"></i>
          No tenés permisos para acceder a esta sección.
        </div>
        <a href="#/" class="btn btn-primary"><i class="fas fa-house me-1"></i>Volver al inicio</a>
      </div>
    `;
    document.getElementById("app").innerHTML = Navbar.render("") + contenido;
    Navbar.bind();
  },
};
